import { render, staticRenderFns } from "./17PointsModal.vue?vue&type=template&id=1a8df81b&scoped=true"
import script from "./17PointsModal.vue?vue&type=script&lang=js"
export * from "./17PointsModal.vue?vue&type=script&lang=js"
import style0 from "./17PointsModal.vue?vue&type=style&index=0&id=1a8df81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8df81b",
  null
  
)

export default component.exports